//Generated File 
export default class NavigationType{
	static readonly First = `First`;
	static readonly Last = `Last`;
	static readonly Next = `Next`;
	static readonly Previous = `Previous`;
}
